import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';

import { DefaultButton } from 'common/components';
import { withTheme } from 'common/styling/theme';
import { payCommissions } from '../../_redux';

import { staticStyles, getDynamicStyles } from './style';

const PayCommissionForm = ({
  selectedRecords,
  filter,
  handleSubmit,
  togglePayCommissionModal,
  submitting,
  invalid,
  error,
  theme,
  dispatch,
}) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const totalAmount = selectedRecords.reduce((acc, cur) => acc + Number(cur.availableAmount.amount), 0);
  const submit = handleSubmit(values =>
    payCommissions({ ...values, filter, commissionIds: selectedRecords.map(item => item.id) }, dispatch)
  );

  return (
    <form className="PayCommissionForm" onSubmit={submit}>
      <div className="PayCommissionForm__line">
        <FormattedMessage id="justRewardsSelected">
          {txt => <span className="PayCommissionForm__title">{txt}</span>}
        </FormattedMessage>
        <span>{selectedRecords.map(item => item.id).join(', ')}</span>
      </div>
      <div className="PayCommissionForm__line">
        <FormattedMessage id="justAmount">
          {txt => <span className="PayCommissionForm__title">{txt}</span>}
        </FormattedMessage>
        <span>{`${totalAmount} USD`}</span>
      </div>
      <div className="PayCommissionForm__line">
        <DefaultButton
          type="submit"
          textId="justPayRewards"
          loading={submitting}
          disabled={invalid || submitting}
          filled
        />
        <DefaultButton textId="justCancel" onClick={togglePayCommissionModal} />
      </div>
      {error && <strong>{error}</strong>}
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </form>
  );
};

PayCommissionForm.propTypes = {
  selectedRecords: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  togglePayCommissionModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
  theme: PropTypes.object,
};

PayCommissionForm.defaultProps = {
  error: '',
  theme: {},
};

export default compose(
  withTheme(),
  reduxForm({
    form: 'PayCommissionForm',
    onSubmitSuccess(result, dispatch, props) {
      props.togglePayCommissionModal();
      props.setSelectedRecords([]);
    },
  })
)(PayCommissionForm);
export { PayCommissionForm };
